import { render, staticRenderFns } from "./BeiguoOrder.vue?vue&type=template&id=9b9eef16&scoped=true"
import script from "./BeiguoOrder.vue?vue&type=script&lang=js"
export * from "./BeiguoOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b9eef16",
  null
  
)

export default component.exports